import { Link } from "react-router-dom";
import { Alert, styled } from "@monolith-forensics/monolith-ui";
import { useFeatures } from "@/contexts/FeaturesContext";

// Alert takes no className, so the spacing goes on a wrapper that only
// renders with the banner.
const StyledBanner = styled.div`
  margin-bottom: 10px;
  a {
    margin-left: 12px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

/**
 * Cutover notice on the legacy Software and Equipment pages (ENG-2346).
 * Not dismissable, since it should stay up until the pages are gone. Nothing
 * with lab_assets off, so it only shows once Assets is live. `kind` names
 * what this page manages, matching the Hardware / Software labels on Assets.
 */
export const LegacyAssetsDeprecationBanner: React.FC<{
  kind: "software" | "hardware";
}> = ({ kind }) => {
  const { hasFeatures, FEATURES } = useFeatures();

  if (!hasFeatures([FEATURES.LAB_ASSETS])) return null;

  return (
    <StyledBanner data-testid="legacy-assets-deprecation-banner">
      <Alert variant="warning" title="Software and Equipment have moved">
        <div>
          They now live together on the Assets page, which includes additional
          features. You can still manage your {kind} here until January 31,
          2027.
          <Link to="/assets">Go to Assets</Link>
        </div>
      </Alert>
    </StyledBanner>
  );
};
